module.exports = __webpack_public_path__ + "media/images/duracion-724d120ad66b5eeac3dbc94495209392.png";